<div class="max-w-[700px] mx-auto animate-fadeIn pb-10">
    <div class="w-full space-y-6">
        <!-- Header -->
        <div class="flex justify-between items-center">
            <h2 class="text-2xl md:text-28 font-bold text-dark">Education</h2>
            <button type="button" 
                    (click)="openDialog()" 
                    class="text-primary hover:text-blue-600 font-semibold flex items-center gap-1.5 transition-colors text-16 lg:text-18">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M12 4v16m8-8H4" />
                </svg>
                Add Education
            </button>
        </div>
        
        <!-- <p class="text-gray-500 text-sm lg:text-16 leading-relaxed">
            This doesn't just have to be a degree. Adding any relevant education helps clients understand your expertise.
        </p> -->

        <!-- Education List (Cards) -->
        <div class="space-y-4 pt-2">
            <div *ngFor="let item of education.value; let i = index" 
                 class="group relative border border-gray-100 rounded-2xl p-5 md:p-7 bg-white shadow-sm hover:shadow-xl hover:border-primary/20 transition-all duration-500 overflow-hidden">
                <!-- Decorative Accent -->
                <div class="absolute top-0 left-0 w-1.5 h-full bg-primary opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>

                <div class="flex flex-col md:flex-row justify-between items-start gap-4">
                    <div class="space-y-4 flex-1 w-full">
                        <!-- Top Row: Title & Badge -->
                        <div class="flex flex-wrap items-center gap-3">
                            <h4 class="text-xl font-extrabold text-[#1A1A1A] group-hover:text-primary transition-colors duration-300 tracking-tight leading-tight uppercase">
                                {{item.university_name}}
                            </h4>
                            <span class="inline-flex items-center px-2.5 py-1 rounded-md bg-blue-50 text-primary text-[11px] font-bold uppercase tracking-widest border border-blue-100/50">
                                {{item.degree_type}}
                            </span>
                        </div>

                        <!-- Meta Info Row -->
                        <div class="flex flex-wrap items-center gap-x-6 gap-y-3">
                            <!-- Location -->
                            <div class="flex items-center gap-2 text-gray-500 group/meta">
                                <div class="w-8 h-8 rounded-lg bg-gray-100 flex items-center justify-center group-hover/meta:bg-blue-50 transition-colors">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 group-hover/meta:text-primary transition-colors" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                                    </svg>
                                </div>
                                <span class="text-sm font-medium">{{item.university_address}}</span>
                            </div>

                            <!-- Specialization -->
                            <div class="flex items-center gap-2 text-gray-500 group/meta">
                                <div class="w-8 h-8 rounded-lg bg-gray-100 flex items-center justify-center group-hover/meta:bg-blue-50 transition-colors">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 group-hover/meta:text-primary transition-colors" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path d="M12 14l9-5-9-5-9 5 9 5z" />
                                        <path d="M12 14l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14z" />
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 14l9-5-9-5-9 5 9 5zm0 0l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14zm-4 6v-7.5l4-2.222" />
                                    </svg>
                                </div>
                                <span class="text-sm font-medium">{{item.specialization}}</span>
                            </div>

                            <!-- Duration -->
                            <div class="flex items-center gap-2 text-gray-500 group/meta">
                                <div class="w-8 h-8 rounded-lg bg-gray-100 flex items-center justify-center group-hover/meta:bg-blue-50 transition-colors">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 group-hover/meta:text-primary transition-colors" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                                    </svg>
                                </div>
                                <div class="flex flex-col">
                                    <span class="text-[10px] uppercase tracking-wider font-bold text-gray-400 leading-none mb-0.5">Academic Years</span>
                                    <span class="text-sm font-semibold text-dark">{{item.start_year}} — {{item.end_year}}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Actions -->
                    <div class="flex items-center gap-2 self-end md:self-start pt-2 md:pt-0">
                        <button type="button" 
                                (click)="openDialog(i)" 
                                class="w-11 h-11 flex items-center justify-center rounded-xl bg-white border border-gray-100 text-gray-400 hover:text-primary hover:border-primary hover:shadow-md transition-all duration-300 active:scale-95"
                                title="Edit education">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
                            </svg>
                        </button>
                        <button type="button" 
                                (click)="removeEducationItem(i)" 
                                class="w-11 h-11 flex items-center justify-center rounded-xl bg-white border border-gray-100 text-gray-400 hover:text-red-500 hover:border-red-200 hover:shadow-md transition-all duration-300 active:scale-95"
                                title="Remove education">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                            </svg>
                        </button>
                    </div>
                </div>
            </div>

            <!-- Empty State Removed -->
        </div>

        <!-- Navigation Buttons -->
        <div class="flex items-center gap-4 mt-8 pt-4">
            <button type="button" 
                    class="flex-1 flex items-center justify-center text-base font-medium border border-gray-200 bg-white text-gray-700 hover:bg-gray-50 outline-none rounded-lg transition-all p-4" 
                    (click)="goBack()">
                Back
            </button>
            
            <button type="button" 
                    class="flex-1 flex items-center justify-center text-base font-medium border border-primary bg-primary hover:bg-blue-700 text-white outline-none rounded-lg transition-all p-4 shadow-sm font-bold" 
                    (click)="education.value.length === 0 ? onSkip() : updateEducation()"
                    [disabled]="isBtnLoading">
                <span class="inline-block" *ngIf="isBtnLoading">
                    <svg class="animate-spin -ml-1 mr-3 h-5 w-5 text-inherit" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"> 
                        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle> 
                        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path> 
                    </svg>
                </span>
                {{ education.value.length === 0 ? 'Skip' : 'Continue' }}
            </button>
        </div>
    </div>
</div>

<!-- Reusable Add/Edit Education Form Modal -->
<app-education-form 
    [(visible)]="displayDialog" 
    [editingItem]="editingIndex !== null ? education.at(editingIndex).value : null" 
    (saved)="onEducationSaved($event)">
</app-education-form>

<!-- Skip Confirmation Modal -->
<p-dialog [(visible)]="displaySkipDialog" 
          [modal]="true" 
          [showHeader]="false"
          [style]="{width: '90vw', maxWidth: '420px', borderRadius: '32px', overflow: 'hidden', border: 'none'}"
          [contentStyle]="{padding: '0', borderRadius: '32px'}"
          [draggable]="false"
          [resizable]="false"
          styleClass="premium-modal"
          (onHide)="displaySkipDialog = false">
    
    <div class="relative p-6 lg:p-8 bg-white rounded-[32px] overflow-hidden border border-blue-50/50 shadow-2xl">
        <!-- Background Decorative Glow -->
        <div class="absolute -top-24 -left-24 w-48 h-48 bg-primary/5 rounded-full blur-3xl"></div>
        
        <!-- Close Button -->
        <button (click)="displaySkipDialog = false" class="absolute top-6 right-6 p-2.5 text-gray-400 hover:text-dark hover:bg-gray-100/50 rounded-full transition-all duration-500 hover:rotate-90 hover:scale-110 active:scale-90 z-10">
            <svg class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M6 18L18 6M6 6l12 12" /></svg>
        </button>

        <div class="text-center space-y-6 mt-4">
            <!-- Icon with Glow -->
            <div class="relative mx-auto w-20 h-20 flex items-center justify-center">
                <div class="absolute inset-0 bg-primary/20 rounded-full blur-xl scale-125 animate-pulse"></div>
                <div class="relative w-full h-full bg-gradient-to-br from-blue-500 to-primary rounded-3xl flex items-center justify-center shadow-lg shadow-blue-200 transform -rotate-6 transition-transform duration-500 hover:rotate-0">
                    <svg class="w-10 h-10 text-white transform rotate-6 transition-transform duration-500 hover:rotate-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                </div>
            </div>

            <!-- Content -->
            <div class="space-y-3">
                <h3 class="text-2xl font-black text-dark tracking-tight leading-tight">Are you sure you want to skip?</h3>
                <p class="text-gray-500 text-base leading-relaxed">Adding your education helps you get <span class="text-primary font-bold">more students</span>. You can always add it later.</p>
            </div>

            <!-- Buttons -->
            <div class="flex flex-col sm:flex-row items-center gap-3 pt-4">
                <button type="button" 
                        (click)="displaySkipDialog = false" 
                        class="w-full sm:w-1/2 px-6 py-4 text-gray-500 hover:text-dark hover:bg-gray-50 rounded-2xl transition-all duration-300 font-bold text-base order-2 sm:order-1">
                    Not now
                </button>
                <button type="button" 
                        (click)="confirmSkip()" 
                        class="w-full sm:w-1/2 px-6 py-4 bg-gradient-to-r from-blue-600 to-primary text-white rounded-2xl transition-all duration-300 font-bold text-base shadow-xl shadow-blue-100 hover:shadow-blue-200 hover:-translate-y-1 active:scale-95 order-1 sm:order-2">
                    Confirm Skip
                </button>
            </div>
        </div>
    </div>
</p-dialog>